import { TooltipWrapper } from '@components/TooltipWrapper';
import type * as React from 'react';
import { Link } from 'react-router-dom';
import { FundIcon } from './lib/fundIcon';
import { IsinIcon } from './lib/isinIcon';
import type { TranchePropsType } from './types';

const infoText = {
  A: 'Ausschütter',
  'A Ausland': 'Ausschütter Auslandstranche',
  T: 'Thesaurierer',
  'VT In- und Ausland': 'Vollthesaurierer Inlands- und Auslandstranche',
  'VT Ausland': 'Vollthesaurierer Auslandstranche',
  VTA: 'Vollthesaurierer Auslandstranche',
  AA: 'Ausschütter Auslandstranche',
  VT: 'Vollthesaurierer Inlands- und Auslandstranche',
};

const Tranche: React.FC<TranchePropsType> = (props: TranchePropsType) => {
  const { isFirst, isExpanded } = props;
  const tProps = props.tranche;
  const fProps = props.fund;
  const isSingleTrancheFund = props.trancheCount === 1;

  const isinIconJSX = <IsinIcon onClick={props.expandFn} trancheCount={props.trancheCount} className="mx-auto block h-auto max-h-[30px] w-auto" />;
  const isinLinkJSX = (
    <Link
      to={tProps.url}
      state={{
        ...props.location.state,
        liveFilterInfo: props.liveFilterInfo,
        detailFilterInfo: props.detailFilterInfo,
        detailFilterVisible: props.detailFilterVisible,
        largeinvestmentfonds: props.fund.largeinvestmentfonds,
        salesAdmission: props.salesAdmission,
      }}
    >
      {tProps.isin}
    </Link>
  );

  const fundNameJSX = (
    <div className="flex items-center justify-start">
      <div className="FundName-inline font-body">
        {isSingleTrancheFund ? (
          <Link
            to={tProps.url}
            state={{
              ...props.location.state,
              liveFilterInfo: props.liveFilterInfo,
              detailFilterInfo: props.detailFilterInfo,
              detailFilterVisible: props.detailFilterVisible,
              largeinvestmentfonds: props.fund.largeinvestmentfonds,
              salesAdmission: props.salesAdmission,
            }}
          >
            {fProps.fundsname}
          </Link>
        ) : (
          fProps.fundsname
        )}
      </div>
      {isSingleTrancheFund ? null : <FundIcon expanded={isExpanded} />}
    </div>
  );

  const displName = selectWithRules(fundNameJSX, null, 1, 1, 0, isFirst, isExpanded);
  const displCategory = selectWithRules(fProps.category, null, 1, 1, 1, isFirst, isExpanded);
  const displIsin = selectWithRules(isinIconJSX, isinLinkJSX, 1, 2, 2, isFirst, isExpanded);
  const displCurrency = selectWithRules(fProps.currency, tProps.currency, 1, 2, 2, isFirst, isExpanded);
  const displDistribution = selectWithRules(fProps.distribution, tProps.distribution, 1, 2, 2, isFirst, isExpanded);

  return (
    <tr className="Tranche max-[620px]:flex max-[620px]:items-start max-[620px]:justify-between max-[620px]:border-b max-[620px]:border-[#ececec] max-[620px]:py-[5px] max-[440px]:flex-wrap">
      <td
        className={`Tranche-name w-[40%] py-1.5 text-sm leading-[30px] text-black max-[1100px]:w-[60%] max-[620px]:w-full max-[620px]:inline-block max-[620px]:border-b-0 max-[620px]:bg-none ${isFirst ? '' : 'max-[620px]:hidden'} max-[440px]:block! max-[440px]:w-full max-[440px]:min-w-full max-[440px]:max-w-full [&_a]:flex [&_a]:w-full [&_a]:text-black [&_a]:no-underline [&_a]:outline-none`}
        onClick={isFirst ? props.expandFn : null}
        key={`${props.tranche.id}_1`}
      >
        {displName}
      </td>
      <td
        className={`Tranche-isin py-1.5 pr-3 text-accent max-[620px]:ml-auto max-[620px]:inline-block max-[620px]:w-[30%] max-[620px]:min-w-[30%] max-[620px]:max-w-[30%] max-[620px]:border-b-0 max-[620px]:bg-none max-[620px]:pl-[5px] max-[440px]:block! max-[440px]:w-full max-[440px]:min-w-full max-[440px]:max-w-full ${!isExpanded && !isSingleTrancheFund ? 'max-[440px]:[&_span]:justify-center' : 'max-[440px]:[&_span]:justify-start'} [&_a]:text-accent [&_a]:no-underline [&_a]:outline-none ${isExpanded || isSingleTrancheFund ? '[&_a]:flex [&_a]:items-center [&_a]:justify-start [&_a]:before:mr-[-10px] [&_a]:before:inline-block [&_a]:before:min-w-5 [&_a]:before:translate-x-[-5px] [&_a]:before:translate-y-[2px] [&_a]:before:content-[url(/static/front/assets/chevron/chevron-isin.png)]' : ''}`}
        key={`${props.tranche.id}_2`}
      >
        <span className={`flex items-center justify-start ${!isExpanded && !isSingleTrancheFund ? 'max-w-[100px] max-[440px]:max-w-full' : ''}`}>{displIsin}</span>
      </td>
      <td className="Tranche-category py-1.5 pr-2.5 max-[1100px]:hidden max-[620px]:hidden" key={`${props.tranche.id}_3`}>
        {displCategory}
      </td>
      <td className="Tranche-distribution py-1.5 max-[1100px]:hidden max-[620px]:hidden" key={`${props.tranche.id}_4`}>
        {infoText[displDistribution] ? <TooltipWrapper text={infoText[displDistribution]}>{displDistribution}</TooltipWrapper> : displDistribution}
      </td>
      <td className="Tranche-currency py-1.5 text-right max-[620px]:hidden" key={`${props.tranche.id}_5`}>
        {displCurrency}
      </td>
    </tr>
  );
};

const selectWithRules = (firstVal: any, secondVal: any, whichInFirst: number, whichInFirstIfExpanded: number, whichInOtherwise: number, isFirst: boolean, isExpanded: boolean): any => {
  if (isFirst) {
    if (isExpanded) {
      return whichInFirstIfExpanded === 1 ? firstVal : whichInFirstIfExpanded === 2 ? secondVal : null;
    } else {
      return whichInFirst === 1 ? firstVal : whichInFirst === 2 ? secondVal : null;
    }
  } else {
    return whichInOtherwise === 1 ? firstVal : whichInOtherwise === 2 ? secondVal : null;
  }
};

export { Tranche };
